import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmployeeSpecializationConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmployeeSpecializationService } from './api/employeeSpecialization.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmployeeSpecializationApiModule {
    public static forRoot(configurationFactory: () => EmployeeSpecializationConfiguration): ModuleWithProviders<EmployeeSpecializationApiModule> {
        return {
            ngModule: EmployeeSpecializationApiModule,
            providers: [ { provide: EmployeeSpecializationConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmployeeSpecializationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmployeeSpecializationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
